import { number } from 'superstruct';
import * as s from 'superstruct';
import { laterCoerce } from './laterCoerce';

/**
 * Limit a value to some range. Coerces the value to the range if it is outside the range.
 *
 * Note: `min` and `max` are both inclusive limits.
 */
export function clamp(struct, {
  min = -Infinity,
  max = Infinity
}) {
  if (max < min) {
    throw new RangeError('min must be greater than or equal to max');
  }

  // Use laterCoerce to allow any parsing coercions in struct to run before the value is clamped.
  return laterCoerce(s.max(s.min(struct, min), max), number(), value => {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  });
}